/** Longest free-text answer a parent may give to a registration question. */
export const MAX_FREE_TEXT_ANSWER_LENGTH = 600;

/** From this length on the character counter is shown under the answer. */
export const FREE_TEXT_ANSWER_COUNTER_FROM = 480;

export const getAnswerLength = (answer: any): number =>
  typeof answer === "string" ? answer.length : 0;

export const isAnswerTooLong = (answer: any): boolean =>
  getAnswerLength(answer) > MAX_FREE_TEXT_ANSWER_LENGTH;



// WEBPACK FOOTER //
// ./src/app/_helpers/free-text-answer-limit.ts